import { Post } from "@forcode/domain";
import { Typography } from "../../atom";
import css from "./PostHeader.module.css";

export interface IPostHeaderProps {
  post: Post;
}

const BASE_CLASS = "f-OrganismPostHeader";

export const PostHeader = ({ post }: IPostHeaderProps) => {
  const { title, excerpt } = post;
  const hasExcerpt = Boolean(excerpt);

  return (
    <header className={css[BASE_CLASS]}>
      <Typography as="h2" className={css[`${BASE_CLASS}-title`]}>
        {title}
      </Typography>
      {hasExcerpt && <Typography as="p">{`${excerpt}`}</Typography>}
    </header>
  );
};
